import React from "react";
import styles from "../../../styles/oorPdf.module.css";
import { convertUTCToLocal, formatDob } from "../../../utils/helper";

const safe = (v, f = "—") => (v != null && v !== "" ? v : f);



const OORSummaryPreview = ({ 
  logo, 
  reportRange, 
  providerName, 
  oorRecords = [],
  patientDetails = null,
  escalatedReadingsFrequency = null
}) => {
  const patientName =
    patientDetails?.user
      ? `${patientDetails.user.first_name || ""} ${patientDetails.user.last_name || ""}`.trim()
      : oorRecords[0]?.patient_name || "—";
  const dob = patientDetails?.user?.dob
    ? formatDob(patientDetails.user.dob)
    : oorRecords[0]?.dob
    ? formatDob(oorRecords[0].dob)
    : "—";
  const doctor = patientDetails?.provider
    ? `${patientDetails.provider.first_name || ""} ${patientDetails.provider.last_name || ""}`.trim() || "—"
    : "—";
  const subaccount = patientDetails?.location?.name || "—";

  return (
    <div className={styles.previewContainer}>
      <div className={styles.header}>
        {logo && (
          <div className={styles.logoContainer}>
            <img src={logo} className={styles.logo} alt="logo" />
            <div className={styles.logoUnderline}></div>
          </div>
        )}
        {patientDetails?.location?.name && (
          <div className={styles.subaccountName}>{patientDetails.location.name}</div>
        )}
        <h2 className={styles.title}>Out of Range Summary Report</h2>
      </div>

      <div className={styles.patientInfo}>
        <div className={styles.patientInfoLeft}>
          <div>
            <span className={styles.label}>Patient Name:</span>
            <span className={styles.value}> {patientName}</span>
          </div>
          <div>
            <span className={styles.label}>DOB:</span>
            <span className={styles.value}> {dob}</span>
          </div>
          {escalatedReadingsFrequency != null && (
            <div>
              <span className={styles.label}>Percentage:</span>
              <span className={styles.value}> {escalatedReadingsFrequency}%</span>
            </div>
          )}
        </div>
        <div className={styles.patientInfoRight}>
          <div>
            <span className={styles.label}>Provider Name:</span>
            <span className={styles.value}> {doctor}</span>
          </div>
          <div>
            <span className={styles.label}>Subaccount Name:</span>
            <span className={styles.value}> {subaccount}</span>
          </div>
        </div>
      </div>

      <table className={styles.table}>
        <thead>
          <tr>
            <th>Date</th>
            <th>Type</th>
            <th>Value</th>
            <th>Category</th>
          </tr>
        </thead>
        <tbody>
          {oorRecords.length === 0 ? (
            <tr>
              <td colSpan={4} style={{ padding: 12, color: "#666" }}>No records</td>
            </tr>
          ) : (
            oorRecords.map((r, i) => (
              <tr key={i}>
                <td>{r.date ? convertUTCToLocal(r.date) : "—"}</td>
                <td>{safe(r.type || r.reading_type_display)}</td>
                <td>{safe(r.value)}</td>
                <td>{safe(r.category || r.monitoring_category)}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <div className={styles.footer}>
        <div className={styles.footerLeft}>Out of Range Summary Report</div>
       
        <div className={styles.footerRight}>{convertUTCToLocal(new Date().toISOString(), navigator.language, true)}</div>
      </div>
    </div>
  );
};

export default OORSummaryPreview;
